module.exports = __webpack_public_path__ + "img/zero.2316b1f0.png";